/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import apiClient from '../apiClient';
import {
    ActivityDto,
    CashRegisterModelShortDto,
    CityResource,
    FirmwareVersionDTO,
    FiscalDriverVersionDto,
    OperatorShortDto,
    RegionResource,
    StoreTypeResource,
    TaxationTypeDTO,
    TaxAuthorityDTO,
    UserShortDto,
} from './shortListsClient.typings';

async function getCashRegisterModels(): Promise<CashRegisterModelShortDto[]> {
    return apiClient.get<CashRegisterModelShortDto[]>('1.0.0/cashRegisterModels/short');
}

async function getOperatorsList(): Promise<OperatorShortDto[]> {
    return apiClient.get<OperatorShortDto[]>('1.0.0/operators/short');
}

async function getUsersList(): Promise<UserShortDto[]> {
    return apiClient.get<UserShortDto[]>('1.0.0/users/short');
}

async function getStoreTypes(): Promise<StoreTypeResource[]> {
    return apiClient.get<StoreTypeResource[]>('1.0.0/stores/types');
}

async function getFirmwareVersions(): Promise<FirmwareVersionDTO[]> {
    return apiClient.get<FirmwareVersionDTO[]>('1.0.0/firmwareVersions');
}

async function getFiscalDriverVersions(): Promise<FiscalDriverVersionDto[]> {
    return apiClient.get<FiscalDriverVersionDto[]>('1.0.0/fiscalDriverVersions');
}

async function getTaxAuthorities(): Promise<TaxAuthorityDTO[]> {
    return apiClient.get<TaxAuthorityDTO[]>('1.0.0/taxAuthorities');
}

async function getTaxationTypes(): Promise<TaxationTypeDTO[]> {
    return apiClient.get<TaxationTypeDTO[]>('1.0.0/taxationTypes');
}

function getCities(): Promise<CityResource[]> {
    return apiClient.get<CityResource[]>('1.0.0/cities');
}

function getRegions(): Promise<RegionResource[]> {
    return apiClient.get<RegionResource[]>('1.0.0/regions');
}

function getListOfMainActivities(): Promise<ActivityDto[]> {
    return apiClient.get<ActivityDto[]>('1.0.0/activities/main');
}

function getListOfMiddleActivities(): Promise<ActivityDto[]> {
    return apiClient.get<ActivityDto[]>('1.0.0/activities/middle');
}

function getListOfLowerActivities(): Promise<ActivityDto[]> {
    return apiClient.get<ActivityDto[]>('1.0.0/activities/lower');
}

export const shortListsClient = {
    getStoreTypes,
    getCashRegisterModels,
    getOperatorsList,
    getUsersList,
    getFirmwareVersions,
    getFiscalDriverVersions,
    getTaxAuthorities,
    getTaxationTypes,
    getCities,
    getRegions,
    getListOfMainActivities,
    getListOfMiddleActivities,
    getListOfLowerActivities,
};
